var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ManagePageContainer',{staticClass:"page",attrs:{"id":"GradeDataSearch"}},[_c('GradeDataSearchInput',{class:_vm.inputContent,on:{"emitting":_vm.showDetails}}),_c('div',{staticClass:"detail_container"},[_c('GradeDataDetail',{class:_vm.detailContent,attrs:{"gradeList":_vm.gradeDataDetailList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }